import React, { useMemo } from 'react'
import 'date-fns';
import {
  Paper, Grid, Button, TextField, InputLabel, MenuItem, FormControl, Select, Typography,
  makeStyles, Theme, createStyles, FormControlLabel,
  FormHelperText, CircularProgress, Checkbox,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { green } from '@material-ui/core/colors';
import { typeputForm } from '../../../../../api/helpline/qa';
import { typeContractItemList } from '../../../../../api/helpline/keiyaku';



const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '90%'
    },
    mWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "80%",
      minWidth: "40%",
    },
    suport: {
      marginTop: theme.spacing(1),
      width: "80%",
    },
    departmentWidth: {
      marginTop: theme.spacing(1),
      width: "90%",
    },
    lWidth: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
    button: {
      margin: theme.spacing(1),
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    previewChip: {
      marginBottom: theme.spacing(1),
      minWidth: "80px",
      maxWidth: "250px",
    },
    attachedIcon: {
      width: '30px'
    },
    attachedremoveButton: {
      width: '25px'
    }
  }),
);

interface Prop {
  basicForm: typeputForm,
  cisUserList: {
    userCd: string;
    userName: string;
  }[],
  loginUser: boolean,
  reqItem: {
    qPersonCd: boolean;
    qaTitle: boolean;
    qaSeCd: boolean;
    custmNo: boolean;
    keiyakuNo: boolean;
  },
  contractItemList: typeContractItemList[],
  handleChangeSeCd: (seObj: {
    userCd: string;
    userName: string;
  }) => void
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  handleClickMenu: (event: React.ChangeEvent<{ id?: string | undefined; }>) => void,
  handleSetLoginUserCd: (event: React.ChangeEvent<HTMLInputElement>) => void,
  onSubmit: () => void,
  loading: boolean,
}

const FormAreaBasicEdit: React.FC<Prop> = (props) => {
  const classes = useStyles();
  const { basicForm, cisUserList, loginUser, reqItem, contractItemList, handleChangeSeCd, handleChangeForm, handleClickMenu, handleSetLoginUserCd, onSubmit, loading } = props

  const check = useMemo(() => reqItem.custmNo ? true : reqItem.keiyakuNo ? true : reqItem.qPersonCd ? true : reqItem.qaTitle ? true : loginUser ? false : reqItem.qaSeCd, [reqItem, loginUser])

  return (
    <form>
      <Grid container direction="row" justify="center" alignItems="center">
        <Paper elevation={0} className={classes.paper}>
          <Grid item xs={10}>
            <Grid container spacing={1} direction="row" justify="flex-start" alignItems="center">
              <Grid item xs={5}>
                {cisUserList && cisUserList[0] && //cisUserList[0]追加
                  <FormControl className={classes.lWidth} variant="outlined" margin="dense" error={loginUser ? false : reqItem.qaSeCd}>
                    <Autocomplete
                      id="qaSeCd"
                      disabled={loginUser}
                      disableClearable={true}
                      options={cisUserList}
                      defaultValue={cisUserList!.filter(value => value.userCd === basicForm.qaSeCd)[0]}
                      getOptionLabel={(option) => `${option.userCd} ${option.userName}`}
                      onChange={(event, value) => handleChangeSeCd(value)}
                      renderInput={(params) => (
                        <TextField {...params} label="担当SE" variant="outlined" size="small" required error={loginUser ? false : reqItem.qaSeCd} />
                      )}
                      renderOption={(option, { inputValue }) => {
                        const matches = match( `${option.userCd} ${option.userName}`, inputValue);
                        const parts = parse( `${option.userCd} ${option.userName}`, matches);
                        return (
                          <div>
                            {parts.map((part, index) => (
                              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                              </span>
                            ))}
                          </div>
                        );
                      }}
                    />
                    {loginUser ? false : reqItem.qaSeCd && <FormHelperText>必須項目です</FormHelperText>}
                  </FormControl>
                }
              </Grid>
              <Grid item>
                <FormControlLabel control={<Checkbox checked={loginUser} color="primary" onChange={handleSetLoginUserCd} name="loginUser" size="small" />} label="ログインユーザー" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={10}>
            <FormControl variant="outlined" required className={classes.mWidth} margin="dense" error={reqItem.keiyakuNo}>
              <InputLabel id="keiyakuNo" margin="dense">契約項目</InputLabel>
              <Select
                labelId="keiyakuNo"
                id="keiyakuNo"
                name="keiyakuNo"
                value={basicForm.keiyakuNo}
                onChange={handleChangeForm}
                label="契約項目"
              >
                {contractItemList && (contractItemList.map(value => {
                  return (
                    <MenuItem id={value.keiyakuClsCd} value={value.keiyakuNo} onClick={handleClickMenu}>{value.keiyakuClsName}</MenuItem>
                  )
                }))}
              </Select>
              {reqItem.keiyakuNo && <FormHelperText>必須項目です</FormHelperText>}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction="column" justify="center" alignItems="center">
              <Grid item>
                {check && !loading && <Typography color='error' variant="caption">{`未入力の必須項目があります`}</Typography>}
              </Grid>
              <Grid item>
                <div className={classes.wrapper}>
                  <Button variant="contained" color="primary" size="large"
                    className={classes.button}
                    disabled={check ? true : loading}
                    onClick={onSubmit}>
                    更新
                          </Button>
                  {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </form>
  )
}

export default FormAreaBasicEdit
